// extracted by mini-css-extract-plugin
export default {"strikethrough":"KeaCJN"};